import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ArtikelPreisVkServiceConfig = {
  name: "ArtikelPreisVk",
  annotations: []
} as ServiceConfig;